import { apiLoadSettings, apiSaveSettings } from "./baseApi"

export const apiSaveProductSettings = (data, callback) => {
  apiSaveSettings(data, callback, 'product')
}

export const apiLoadProductSettings = (callback) => {
  apiLoadSettings(callback, 'product')
}
